import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SignView from "../views/SignView.vue";
import ApplicantView from "../views/ApplicantView.vue";
import ApplicantDetailsView from "@/views/admin/ApplicantDetailsView.vue";
import ApplicantSearchView from "@/views/admin/ApplicantSearchView.vue";
import LoginView from "@/views/admin/LoginView.vue";
import UpdateApplicantView from "@/views/UpdateApplicantView.vue";
import DashbordSample from "@/views/admin/DashbordSample.vue";
import UserView from "@/views/admin/UserView.vue";
import Privileges from "@/components/Dashboard/Privileges.vue";
import UserRegister from "@/components/Dashboard/UserRegister.vue";
import GeneralStats from "@/components/Dashboard/GeneralStats.vue";
import ReportsView from "@/views/admin/GeneralReportsView.vue";
import IllegalReportView from "@/views/admin/IllegalReportView.vue";
import FinancialReportsView from "@/views/admin/FinancialReportsView.vue";
import UserActivitesView from "@/views/admin/UserActivitesView.vue";
import ExceptRequestView from "@/views/admin/ExceptRequestView.vue";
import ChartReports from "@/views/admin/ChartReports.vue";
import BarChart from "@/components/BarChart.vue";
import TestBarChart from "@/components/ChartReports/TestBarChart.vue";
import Settings from "@/components/Dashboard/Settings.vue";
const routes = [
 /*  {
    path: "/",
    name: "home",
    component: HomeView,
  }, */
  {
    // path: "/sign",
    path: "/",
    name: "sign",
    meta: {
      title: 'التسجيل والإستعلام',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignView.vue"),
  },
  {
    path: "/applicant/:departId/:nationalityId/:appType/:nationNo?/:passNo?",
    name: "applicant",
    meta: {
      title: 'طلب جديد',
    },
    component:   ApplicantView
  },
  {
    path: "/updateapp/:id/:checkNo/:status",
    name: "updateApp",
    meta: {
      title: 'تحديث الطلب',
    },
    component:   UpdateApplicantView
  },
  {
    path: "/about",
    name: "about",
    meta: {
      title: 'About Page - Example App',
      metaTags: [
        {
          name: 'description',
          content: 'The about page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The about page of our example app.'
        }
      ]
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  /***************************/
  /** admin routes */
  {
    path: "/admin/applicant/:Id",
    name: "AdminApplicant",
    meta: {
      title: 'معلومات المتقدم',
    },
    component:   ApplicantDetailsView
  },
  {
    path: "/admin/applicantsearch",
    name: "AdminApplicantSearch",
    meta: {
      title: 'بحث عن المتقدم',
    },
    component:   ApplicantSearchView
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    meta: {
      title: 'تسجيل الدخول',
    },
    component: () =>
      import( "../views/admin/LoginView.vue"),
  },
  {
    path: "/admin",
    name: "Dashboard",
    meta: {
      title: 'لوحة التحكم',
    },
    component: DashbordSample ,
    children: [
      {
        path: 'dashboard',
        name: 'GeneralStats',
        component: GeneralStats,
        alias: ""
      },
      {
        path: 'privileges',
        name: 'Privileges',
        component: Privileges,
      },
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
      },
      {
        path: 'register',
        name: 'UserRegister',
        component: UserRegister,
      },
    ],
  },
  {
    path: "/admin/profile/:id?",
    name: "profile",
    meta: {
      title: 'معلومات الحساب',
    },
    component:   UserView
  },
  /***************************/
  {
    path: "/admin/reports/generalreport/",
    name: "generalReport",
    meta: {
      title: 'بحث عن تقرير',
    },
    component:   ReportsView
  },
  /***************************/
  {
    path: "/admin/reports/illegalsreport/",
    name: "illegalsReport",
    meta: {
      title: 'تقرير المركبات المخالفة',
    },
    component:   IllegalReportView
  },
  /***************************/
  {
    path: "/admin/reports/financialreport/",
    name: "financialReport",
    meta: {
      title: 'التقارير المالية',
    },
    component:   FinancialReportsView
  },
  /***************************/
  {
    path: "/admin/reports/useractivities/:userId",
    name: "userActivities",
    meta: {
      title: 'تقرير حركة مستخدم',
    },
    component:   UserActivitesView
  },
  /***************************/
  {
    path: "/admin/applicant/extrequest/:id/:type", //id => extendId, not appId
    name: "extendRequest",
    meta: {
      title: 'عرض طلب تمديد',
    },
    component:   ExceptRequestView
  },
  /***************************/
  {
    path: "/admin/charts",
    name: "charts",
    meta: {
      title: 'رسوم بيانية',
    },
    component: ChartReports ,
    children: [
      {
        path: 'charts',
        name: 'BarChart',
        component: BarChart,
        alias: ""
      },
      {
        path: 'v2',
        name: 'TestBarChart',
        component: TestBarChart,
      },
    ],
  },
  /***************************/

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // Set or remove body class based on route path
  if (to.path.includes('admin')) {
    document.body.classList.add('admin-background');
  } else {
    document.body.classList.remove('admin-background');
  }

 
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }
  
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(tag => document.head.appendChild(tag)); // Add the meta tags to the document head.
   
  next();
});


export default router;
